<template>
  <div class="myh-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myh_management/myh_management_home' }">密友会管理</el-breadcrumb-item>
      <el-breadcrumb-item>密友会列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">筛选条件</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="120px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="联系方式" prop="contactPhone">
              <el-input v-model="queryForm.contactPhone" clearable placeholder="请输入联系方式" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="queryForm.email" clearable placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="秘书长" prop="secretaryGeneral">
              <el-input v-model="queryForm.secretaryGeneral" clearable placeholder="请输入秘书长" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否关闭" prop="isClosed">
              <el-select
                v-model="queryForm.isClosed"
                clearable
                placeholder="请选择是否关闭"
                style="width: 100%"
              >
                <el-option label="开启" :value="0" />
                <el-option label="关闭" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">

        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
          <el-col :span="2">
            <el-button type="primary" style="width: 100%" @click="handleQuery">查询</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" style="width: 100%" @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="list_card" style="margin-top: 20px">
      <el-row class="title_row">
        <el-col :span="12">
          <div class="list_title title_class">密友会列表</div>
        </el-col>
        <el-col :span="12">
          <div style="text-align: right">
          </div>
        </el-col>
      </el-row>

      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="tableData"
        border
        stripe
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="密友会名称" prop="name" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">{{ scope.row.name || '-' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="简介" prop="intro" min-width="140" show-overflow-tooltip />
        <el-table-column label="联系方式" prop="contactPhone" min-width="140" show-overflow-tooltip />
        <el-table-column label="邮箱" prop="email" min-width="180" />
        <el-table-column label="秘书长" prop="secretaryGeneral" min-width="140" />
        <el-table-column label="是否关闭" prop="isClosed" min-width="140">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isClosed"
              :active-value="1"
              :inactive-value="0"
              active-color="#f56c6c"
              inactive-color="#67c23a"
              :disabled="!!switchLoadingMap[scope.row.id]"
              @change="handleClosedSwitchChange(scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="180" show-overflow-tooltip />
        <el-table-column label="创建时间" prop="createTime" min-width="180" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" size="small" class="danger-text-btn" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryForm.pageNum"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 40, 80]"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      title="修改密友会信息"
      :visible.sync="editDialogVisible"
      width="620px"
      @close="handleEditDialogClose"
    >
      <el-form
        ref="editFormRef"
        :model="editForm"
        :rules="editFormRules"
        label-width="110px"
      >
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="密友会名称" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入密友会名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="秘书长" prop="secretaryGeneral">
              <el-input v-model="editForm.secretaryGeneral" placeholder="请输入秘书长" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="editForm.email" placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactPhone">
              <el-input v-model="editForm.contactPhone" placeholder="请输入联系方式" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="简介" prop="intro">
          <el-input
            v-model="editForm.intro"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入简介"
          />
        </el-form-item>
        <el-form-item label="是否关闭" prop="isClosed">
          <el-switch
            v-model="editForm.isClosed"
            :active-value="1"
            :inactive-value="0"
            active-color="#f56c6c"
            inactive-color="#67c23a"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="handleSaveEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { myhClubListPage, myhClubOpen, myhClubClose, myhClubDelete, myhClubSaveOrUpdate } from '@/http/api'

export default {
  name: 'MyhList',
  data () {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        contactPhone: '',
        email: '',
        secretaryGeneral: '',
        isClosed: ''
      },
      tableData: [],
      total: 0,
      switchLoadingMap: {},
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: '',
        name: '',
        secretaryGeneral: '',
        email: '',
        contactPhone: '',
        intro: '',
        isClosed: 0,
        remark: ''
      },
      editFormRules: {
        name: [{ required: true, message: '请输入密友会名称', trigger: 'blur' }],
        secretaryGeneral: [{ required: true, message: '请输入秘书长', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    buildQueryParams () {
      const params = {
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize
      }
      if (this.queryForm.contactPhone) params.contactPhone = this.queryForm.contactPhone
      if (this.queryForm.email) params.email = this.queryForm.email
      if (this.queryForm.secretaryGeneral) params.secretaryGeneral = this.queryForm.secretaryGeneral
      if (this.queryForm.isClosed !== '' && this.queryForm.isClosed !== null && this.queryForm.isClosed !== undefined) {
        params.isClosed = this.queryForm.isClosed
      }
      return params
    },
    getList () {
      myhClubListPage(this.buildQueryParams()).then((res) => {
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
      })
    },
    handleQuery () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleReset () {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        contactPhone: '',
        email: '',
        secretaryGeneral: '',
        isClosed: ''
      }
      this.getList()
    },
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.queryForm.pageNum = page
      this.getList()
    },
    handleClosedSwitchChange (row, value) {
      const oldValue = value === 1 ? 0 : 1
      this.$set(this.switchLoadingMap, row.id, true)
      const api = value === 1 ? myhClubClose : myhClubOpen
      api({ id: row.id }).then(() => {
        this.$message.success(value === 1 ? '已关闭' : '已开启')
      }).catch(() => {
        row.isClosed = oldValue
      }).finally(() => {
        this.$set(this.switchLoadingMap, row.id, false)
      })
    },
    handleDelete (row) {
      this.$confirm('确认删除该密友会吗？删除后不可恢复。', '删除确认', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myhClubDelete({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    },
    handleEdit (row) {
      this.editForm = {
        id: row.id || '',
        name: row.name || '',
        secretaryGeneral: row.secretaryGeneral || '',
        email: row.email || '',
        contactPhone: row.contactPhone || '',
        intro: row.intro || '',
        isClosed: +row.isClosed === 1 ? 1 : 0,
        remark: row.remark || '',
        code: row.code || ''
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    handleEditDialogClose () {
      this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
    },
    handleSaveEdit () {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return
        this.editLoading = true
        myhClubSaveOrUpdate({
          id: this.editForm.id,
          name: this.editForm.name,
          secretaryGeneral: this.editForm.secretaryGeneral,
          email: this.editForm.email,
          contactPhone: this.editForm.contactPhone,
          intro: this.editForm.intro,
          isClosed: this.editForm.isClosed,
          remark: this.editForm.remark,
          code: this.editForm.code
        }).then(() => {
          this.$message.success('保存成功')
          this.editDialogVisible = false
          this.getList()
        }).finally(() => {
          this.editLoading = false
        })
      })
    },
    goDetail (row) {
      if (!row || !row.id) return
      this.$router.push({
        path: '/myh_management/myh_detail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.myh-list-page {
  padding: 0;
}

.filter_Form {
  margin-top: 10px;
}

.danger-text-btn {
  color: #f56c6c;
}
</style>
